// utils/rideUtils.js
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const checkForActiveRideAndNavigate = async ({ userId, navigate }) => {
  try {
    const ridesRef = collection(db, 'riders');
    const rideQuery = query(
      ridesRef,
      where('passengerId', '==', userId),
      where('status', 'in', ['pending', 'assigned', 'on_route', 'arrived']),
      limit(1)
    );

    const querySnapshot = await getDocs(rideQuery);

    if (!querySnapshot.empty) {
      const rideDoc = querySnapshot.docs[0];
      const rideData = rideDoc.data();

      const pickup = rideData.pickupLatLng;
      const dropoff = rideData.dropoffLatLng;

      navigate('/trip-tracking', {
        state: {
          rideId: rideDoc.id,
          pickupLatLng: pickup,
          dropoffLatLng: dropoff,
        },
      });
    } else {
      navigate('/map');
    }
  } catch (error) {
    console.error('Error checking for active ride:', error);
    alert('Error checking ride status. Proceeding to map.');
    navigate('/map');
  }
};